import { render, staticRenderFns } from "./TechnologyTextBox.vue?vue&type=template&id=478d1be5&scoped=true&"
import script from "./TechnologyTextBox.vue?vue&type=script&lang=js&"
export * from "./TechnologyTextBox.vue?vue&type=script&lang=js&"
import style0 from "./TechnologyTextBox.vue?vue&type=style&index=0&id=478d1be5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478d1be5",
  null
  
)

export default component.exports